import { defineMessages } from 'react-intl';

export default defineMessages({
  searchPlaceholder: {
    id: 'view.header.selectSeller.search',
    defaultMessage: 'Search seller',
  },
  clearSearch: {
    id: 'view.header.profile.selectSeller.search.clear',
    defaultMessage: 'Clear search value',
  },
  noResults: {
    id: 'view.header.profile.selectSeller.noResults',
    defaultMessage: 'No results for your search',
  },
  copySellerId: {
    id: 'view.header.profile.selectSeller.copy.sellerId',
    defaultMessage: 'Copy seller id',
  },
  copyTenantId: {
    id: 'view.header.profile.selectSeller.copy.tenantId',
    defaultMessage: 'Copy tenant id',
  },
});
